module.exports = __webpack_public_path__ + "img/upload.9058721a.png";